import WarningYellowIcon from "assets/icons/WarningYellowIcon";
import "./styles.scss";
import ErrorRedIcon from "assets/icons/ErrorRedIcon";

export interface NewCFDIErrorsDescriptionProps {
  errors: string []
  duplicated: string []
}

const NewCFDIErrorsDescription = (props: NewCFDIErrorsDescriptionProps) => {
  const { errors, duplicated } = props;
  return(
    <div className="new-cfdi-errors-description">
      <div className="errors-description">
        <span>Algunos de los archivos seleccionados no se cargaron a tu lista de CFDIs.</span>
      </div>
      
      {duplicated.length > 0 &&
        <div className="errors-description-list">
          <div className="description-list-header">
            <span>{`Archivos duplicados (${duplicated.length})`}</span>
          </div>
          <div className="description-list-description">
            <span>Los siguientes archivos ya existen en tu lista de CFDIs, por lo que no se cargaran de nuevo:</span>
          </div>
          <div className="description-list-elements">
            {duplicated.map((element) => (
              <span className="list-element">
                <WarningYellowIcon /> 
                {element.substring(element.lastIndexOf(":") + 1, element.length)}
              </span>
            ))}  
          </div>
        </div>
      }

      {errors.length > 0 &&
        <div className="errors-description-list">
          <div className="description-list-header">
            <span>{`Archivos no cargados (${errors.length})`}</span>
          </div>
          <div className="description-list-description">
            <span>Algo salió mal y no fue posible cargar los siguientes archivos:</span>
          </div>
          <div className="description-list-elements">
            {errors.map((element) => (
              <span className="list-element">
                <ErrorRedIcon /> 
                {element.substring(element.lastIndexOf(":") + 1, element.length)}
              </span>
            ))}  
          </div>
        </div>
      }
    </div>
  )
}

export default NewCFDIErrorsDescription;